var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.5 12.063c0-5.799-4.701-10.5-10.5-10.5-5.798 0-10.5 4.701-10.5 10.5 0 5.24 3.84 9.584 8.86 10.373v-7.337H7.693v-3.036h2.667V9.749c0-2.63 1.568-4.085 3.966-4.085 1.149 0 2.35.205 2.35.205v2.584h-1.324c-1.304 0-1.712.81-1.712 1.64v1.97h2.912l-.465 3.036h-2.446v7.337c5.02-.788 8.86-5.131 8.86-10.373",
    clipRule: "evenodd"
  })));
};
export default SvgFacebook;